const CATEGORY_SLOT_PX = 32;
const SCREEN_HEIGHT_CAP_MULTIPLIER = 2;
const EXPORT_WIDTH = 854;
const EXPORT_MIN_HEIGHT = 480;
const EXPORT_MAX_HEIGHT = 960;

/**
 * Altura em tela. `null` quando a largura ainda não foi medida: não aplicar altura 0.
 */
export function nonConformityScreenHeight(
  width: number,
  categoryCount: number,
): number | null {
  if (width <= 0) {
    return null;
  }

  const sixteenByNine = Math.round((width * 9) / 16);
  const slot = categoryCount * CATEGORY_SLOT_PX;
  const cap = sixteenByNine * SCREEN_HEIGHT_CAP_MULTIPLIER;

  return Math.min(Math.max(sixteenByNine, slot), cap);
}

/**
 * Tamanho da imagem exportada. A largura não depende da tela.
 */
export function nonConformityExportSize(categoryCount: number): {
  width: number;
  height: number;
} {
  const slot = categoryCount * CATEGORY_SLOT_PX;

  return {
    width: EXPORT_WIDTH,
    height: Math.min(Math.max(EXPORT_MIN_HEIGHT, slot), EXPORT_MAX_HEIGHT),
  };
}
